export const CAMPAIGN_SESSION_STORAGE_KEY = 'tripshock_campaign';

const getValue = (value: string | null | undefined) => value?.trim() || '';

const normalizeHostname = (hostname: string) => hostname.toLowerCase().replace(/^www\./, '');

export const getReferrerCampaign = (referrer: string, currentHostname?: string) => {
    if (!referrer) return '';

    try {
        const hostname = new URL(referrer).hostname.toLowerCase();

        if (currentHostname && normalizeHostname(hostname) === normalizeHostname(currentHostname)) {
            return '';
        }

        const parts = hostname.split('.').filter(Boolean);

        if (parts[0] === 'www') {
            parts.shift();
        }

        return parts[0] || '';
    } catch {
        return '';
    }
};

export const resolveCampaign = ({
    search,
    referrer,
    currentHostname,
    storedCampaign,
}: {
    search: string;
    referrer: string;
    currentHostname?: string;
    storedCampaign?: string | null;
}) => {
    const params = new URLSearchParams(search);
    const queryCampaign = getValue(params.get('campaign')) || getValue(params.get('utm_campaign'));

    return (
        queryCampaign || getReferrerCampaign(referrer, currentHostname) || getValue(storedCampaign)
    );
};

export const addCampaignToUrl = (link: string, campaign: string) => {
    if (!campaign) return link;

    try {
        const url = new URL(link);
        url.searchParams.set('campaign', campaign);
        return url.toString();
    } catch {
        const [urlWithoutHash, hash] = link.split('#');
        const separator = urlWithoutHash.includes('?') ? '&' : '?';

        return `${urlWithoutHash}${separator}campaign=${encodeURIComponent(campaign)}${
            hash ? `#${hash}` : ''
        }`;
    }
};
